import { render, staticRenderFns } from "./GerenciarDotacoes.vue?vue&type=template&id=adbf3dd8&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarDotacoes.vue?vue&type=style&index=0&id=adbf3dd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbf3dd8",
  null
  
)

export default component.exports